module.exports = __webpack_public_path__ + "static/media/italy.ab7d14c7.svg";